
import { createStore, applyMiddleware } from "redux"
import { composeWithDevTools } from 'redux-devtools-extension';

import thunk from 'redux-thunk';

import {getParameterByName} from "./UrlHelper"
import UrlEncoder from "./helpers/url-encoder"

import {loadState, saveState} from "./localAppStorage"

import reducers from './reducers'

import { firebaseBackup } from './database'

const uCoder = new UrlEncoder("AIzaSyCb96Oin5QxSdlHOgr9SO5VKUnZge5l5D8")


let savedState = loadState();
let urlData = getParameterByName("data")

/**
 *  Defines black space, if localStorage is empty
 */
if (savedState !== undefined) {
    console.log("STORE STUFF")

    if (Array.isArray(savedState.sceneItems)) {
        savedState = undefined;
    } else if (!Array.isArray(savedState.sceneItems.spaces)) {
        console.log("NO SPACES FOUND.")

        savedState.sceneItems.spaces = [{
            name: "Default Space",
            el: savedState.sceneItems.el,
        }]

        savedState.sceneItems.curSpaceId = 0
    }
}

/**
 *  Initialises Redux Store
 */
const store = createStore(
    reducers,
    savedState,
    composeWithDevTools(
        applyMiddleware(thunk)
    )
);

/**
 *  Saves "sceneItems" into local storage on state update
 */
if (!urlData)
    store.subscribe( () => {
        let data = {
            sceneItems: store.getState().sceneItems
        }
        // Save Items into localstorage
        saveState(data);

        // Upload into firebase
        firebaseBackup(data)
    });


/**
 * 
 * Sets loaded URL data
 * 
 * @param {Object} data 
 * 
 */
const setUrlData = (data) => {
    return {
        type: "URL_LOADED",
        data: JSON.parse(data)
    }
}

/**
 *  Asynchronously loads in data from URL
 */
const loadUrlData = () => {

    return function (dispatch) {
        console.log("LOADING "+urlData)

        uCoder.decodeString(urlData)
        .then( data => {
            dispatch( setUrlData(data) )
        })

        return {
            type: "URL_LOADING",
        }
    }
}

/**
 *  Loads data from URL 
 */
if (urlData) {
    store.dispatch(loadUrlData())
}

export default store



// WEBPACK FOOTER //
// ./src/store.js